'use client'

import { cn } from '@/lib/utils'
import Link from 'next/link'
import { usePathname } from 'next/navigation'

export default function LiveryTabs({}) {
  const pathname = usePathname()

  return (
    <div
      className={cn(
        'no-scrollbar col-span-full col-start-1 -mx-3 my-7 flex items-baseline overflow-x-auto border-b border-neutral-blue-700',
      )}
    >
      {[
        {
          tabName: 'overview',
          tabTitle: 'Overview',
        },
        {
          tabName: 'my-liveries',
          tabTitle: 'My Liveries',
        },
        {
          tabName: 'my-sales',
          tabTitle: 'My Sales',
        },
        {
          tabName: 'upload-livery',
          tabTitle: 'Upload Livery',
        },
        {
          tabName: 'edit-livery',
          tabTitle: 'Edit Livery',
        },
      ].map((tabOption) => (
        <Link
          key={`tab-option-${tabOption.tabTitle}`}
          href={`/profile-manager/liveries/${tabOption.tabName}`}
          className={cn(
            'mx-3 cursor-pointer whitespace-nowrap pb-2 text-p-1 transition-all desktop-sm:text-p-2',
            tabOption.tabName === 'edit-livery' ? 'hidden' : '',
            pathname.split('/').at(3) === 'edit-livery' &&
              tabOption.tabName === 'edit-livery'
              ? 'block! border-b-2 border-primary text-shades-0'
              : '',
            tabOption.tabName === 'upload-livery' ? 'hidden' : '',
            pathname.split('/').at(-1) === 'upload-livery' &&
              tabOption.tabName === 'upload-livery'
              ? 'block! border-b-2 border-primary text-shades-0'
              : '',
            pathname.split('/').at(-1) === tabOption.tabName ||
              (tabOption.tabName === 'calendar' &&
                !pathname.split('driver').at(-1))
              ? 'border-b-2 border-primary text-shades-0'
              : 'text-neutral-blue-500 hover:text-shades-0',
          )}
        >
          {tabOption.tabTitle}
        </Link>
      ))}
    </div>
  )
}
